import utils from '../utils';

describe('utils', () => {
  test('it should have proper object properties', () => {
    expect(utils).toHaveProperty('getJsonFromUrl');
  });
});
